<template>
  <div>
    <div class="row">
      <Master
        :key="reRenderTabsPei"
        :previous-path="previousPath"
        @reRender="reRender()"
      />
    </div>
  </div>
</template>
<script>
import Master from '@/components/pei/Master';
export default {
  components: {
    Master,
  },
  data() {
    return {
      reRenderTabsPei: 0,
      previousPath: null,
      page: {
        icon: 'fas fa-desktop',
        title: 'I. Información del Estudiante',
        routes: ['Inicio', 'PEI', 'Informacion'],
      },
    };
  },
  beforeRouteEnter(_, from, next) {
    next((vm) => {
      vm.previousPath = from;
    });
  },
  methods: {
    reRender() {
      this.reRenderTabsPei += 1;
    },
  },
};
</script>
